import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "./auth";

/**
 * Guards admin routes — redirects to /login when not authenticated.
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default ProtectedRoute;
